module.exports = __webpack_public_path__ + "img/img-2.4cea1947.png";